import { Injectable } from '@angular/core'

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'

import { Observable } from 'rxjs'

import { AuthService } from './../services/auth.service'

 

@Injectable()

export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

 

  intercept(

    request: HttpRequest<any>,

    next: HttpHandler,

  ): Observable<HttpEvent<any>> {

    const currentUser = this.authService.currentUserValue
     if (currentUser && currentUser.accessToken) {
      request = request.clone({

        url: '/api/' + request.url,

        setHeaders: {

          Authorization: `Bearer ${currentUser.accessToken}`,

        },

      })

    } else if (

      currentUser == null &&

      !window.location.href.includes('/login')

    ) {

      //redirect to login or return error page

      this.authService.logout()

      location.reload()

    }

    return next.handle(request)

  }

}

 